import { showChoice } from '@/editor/editor-dialogs';
import type { LevelData } from '@/game/level';
import type { SyncManager } from './sync-manager';
import type { ConflictResolution } from './sync-types';

type Choice = 'keep_both' | 'keep_mine' | 'keep_server';

export async function resolveConflictWithDialog(
  manager: SyncManager,
  local: LevelData,
): Promise<ConflictResolution | null> {
  const choice = await showChoice<Choice>(
    'Sync Conflict',
    `'${local.meta.name}' was edited here and on another device. Pick how to resolve:`,
    [
      { label: 'Keep Both (safe)', value: 'keep_both', primary: true },
      { label: 'Keep Mine', value: 'keep_mine', subtext: "Overwrites the other device's version." },
      { label: 'Keep Server', value: 'keep_server', subtext: "You'll lose local edits." },
    ],
  );
  if (!choice) return null;
  return manager.resolveConflict(local, choice);
}
